<!--
 * @Description: input 去掉前后空格、状态有 【，】
 view:true,false =>true:详情 false:不受控制
-->
<template>
  <CosInputView v-if="view" :value="valueView" v-bind="$attrs" :cosType="cosType" />
  <a-input-number
    v-else
    v-bind="$attrs"
    :placeholder="placeholder || $t('common.pleaseInput')"
    v-model:value="modelValue"
    style="width: 100%"
  >
    <slot name="addonBefore"></slot>
    <slot name="addonAfter"></slot>
  </a-input-number>
</template>
<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { computed } from 'vue'
const props = defineProps({
  value: {
    type: [String, Number]
  },
  view: {
    type: Boolean
  },
  placeholder: {
    type: String
  },
  cosType: {
    type: String
  }
})
// const valueView = computed(() => {
//   /// 这里针对金额来判断是否需要千位分隔法，但是要注意小数点
//   if (props.cosType === 'money') {
//     const value = (props.value ?? '').toString()
//     if (value) {
//       const parts = value.split('.')
//       let floatPart = ''
//       parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//       if (value.includes('.')) { // 有小数部分
//         floatPart = parts[1].toString() // 取得小数部分
//         return parts[0] + '.' + floatPart
//       }
//       return parts[0] + floatPart
//     }
//     return value
//   }
//   return props.value
// })

// const value = 1234.5678
// const formattedValue = value.toLocaleString('en-US', { maximumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.57"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', { minimumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.50"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2
// })
// console.log(formattedValue) // 输出 "1,234.50"

/// 针对千位分割法处理（如果需要针对两位小数那么可以添加上面注释的方法）
const valueView = computed(() => {
  if (props.cosType === 'money') {
    if (!props.value) {
      return ''
    }
    const value = Number(props.value)
    if (isNaN(value)) {
      return ''
    }
    return value.toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  return props.value
})

const emit = defineEmits(['update:value'])
const modelValue = useVModel(props, 'value', emit)
</script>
